
import ReviewsSkeletonSiteRatingsList from './SiteRatingsList.vue';

export default {
  name: 'ReviewsSkeletonBanner',
  components: {
    ReviewsSkeletonSiteRatingsList,
  },
  data() {
    return {};
  },
};
